import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import {type Icon, AlertFillIcon, CheckCircleFillIcon, XCircleFillIcon} from '@primer/octicons-react'
import type {FC} from 'react'
import styles from './FindingsSummary.module.css'
import type {MergeReadiness} from './types'

const ASSESSMENT_LABELS: Record<
  MergeReadiness,
  {label: string; variant: 'success' | 'danger' | 'warning'; icon: Icon}
> = {
  ready: {label: 'Ready to merge', variant: 'success', icon: CheckCircleFillIcon},
  needs_changes: {label: 'Changes needed', variant: 'danger', icon: XCircleFillIcon},
  too_complex: {label: 'Human review recommended', variant: 'warning', icon: AlertFillIcon},
}

interface FindingsSummaryProps {
  mergeReadiness: MergeReadiness | null
  overviewSummary?: string
}

export const FindingsSummary: FC<FindingsSummaryProps> = ({mergeReadiness, overviewSummary}) => {
  const assessment = mergeReadiness ? ASSESSMENT_LABELS[mergeReadiness] : null

  if (!assessment && !overviewSummary) return null

  return (
    <>
      {assessment && (
        <div className={styles.assessment}>
          <h2 className={styles.heading}>Summary</h2>
          <span className={`${styles.assessmentLabel} ${styles[`assessment-${assessment.variant}`]}`}>
            <assessment.icon size={16} className={styles.assessmentIcon} />
            {assessment.label}
          </span>
        </div>
      )}
      {overviewSummary && (
        <VerifiedHTMLDiv
          // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string -- sanitized on the backend
          html={overviewSummary as SafeHTMLString}
          className="tmp-p-3 tmp-my-3 border rounded-3 markdown-body comment-body"
        />
      )}
    </>
  )
}
